import { styled } from 'styled-components';
import Img from '../../assets/images/bg.png';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  justify-content: center;
  align-items: center;
  background: #fcf1ee;
  width: 100%;
  background-size: contain;
  //background-image: url(${Img});
  background-repeat: no-repeat;
  background-color: #fcf1ee;
`;
